// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loading-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: transparent;
  z-index: var(--z-index-loading);
  display: flex;
  align-items: center;
  justify-content: center;
}
.loading-container .loading {
  background: var(--color-white);
  width: 80vw;
  max-width: 400px;
  border-radius: var(--radius);
  padding: 2rem 1rem;
  text-align: center;
}
.loading-container .loading h4 {
  margin-bottom: 0;
  line-height: 1.5;
}`, "",{"version":3,"sources":["webpack://./src/_core/components/common/Loading.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,+BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AACJ;AACI;EACE,8BAAA;EACA,WAAA;EACA,gBAAA;EACA,4BAAA;EACA,kBAAA;EACA,kBAAA;AACN;AAEI;EACE,gBAAA;EACA,gBAAA;AAAN","sourcesContent":[".loading-container {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100vw;\r\n    height: 100vh;\r\n    background: transparent;\r\n    z-index: var(--z-index-loading);\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    \r\n    .loading {\r\n      background: var(--color-white);\r\n      width: 80vw;\r\n      max-width: 400px;\r\n      border-radius: var(--radius);\r\n      padding: 2rem 1rem;\r\n      text-align: center;\r\n    }\r\n    \r\n    .loading h4 {\r\n      margin-bottom: 0;\r\n      line-height: 1.5;\r\n    }\r\n  }\r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
